import { Button } from "@remo-co/ui-core/src/components/Button";
import { useI18n } from "i18n";
import { useDevices } from "modules/audioVideo/hooks";
import {
  AudioStates,
  useAudioOutputTest,
} from "modules/audioVideo/hooks/useAudioOutputTest";
import { useEffect } from "react";
import { useStyles } from "./styles";

export const AudioTest = () => {
  const { activeDevices } = useDevices();
  const { t } = useI18n(["common", "micCamCheck"]);
  const styles = useStyles();
  const activeAudioOutput = activeDevices.audioOutput;

  const { audioState, toggleTestSound, setAudioOutput } = useAudioOutputTest();

  useEffect(() => {
    if (activeAudioOutput) {
      setAudioOutput(activeAudioOutput.deviceId);
    }
  }, [activeAudioOutput, setAudioOutput]);

  return (
    <Button
      size="sm"
      variant="text"
      onClick={toggleTestSound}
      contentClassName={styles.testAudioButton}
      loading={audioState === AudioStates.LOADING}
      data-testid="test-audio-button"
    >
      {t("micCamCheck:test.audio")}
    </Button>
  );
};
